/* Copyright (c) 2020-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { Dropdown, theme, Text, Button, FlexContainer } from "@nordcloud/gnui";
import { SortOrder } from "~/generated/graphql";

export type Option = {
  value: string;
  label: string;
};

type Props<T> = {
  options: Option[];
  value: string;
  direction: SortOrder;
  onSelect: (filter: T) => void;
  onSortChange: (direction: SortOrder) => void;
};

const StyledDropdown = styled.div`
  position: relative;

  & > button {
    position: absolute;
    right: calc(${theme.spacing.spacing01} + 1px);
    top: calc(${theme.spacing.spacing01} + 1px);
  }
`;

export function SortSelector<T>({
  options,
  value,
  direction,
  onSelect,
  onSortChange,
}: Props<T>) {
  const isAscending = direction === SortOrder.Asc;

  return (
    <FlexContainer justifyContent="space-between">
      <FlexContainer>
        <Text tag="div" nowrap mr={theme.spacing.spacing04}>
          Sort by:
        </Text>
        <StyledDropdown>
          <Dropdown
            data-testid="sort-dropdown"
            name="Select"
            options={options}
            onChange={onSelect as (filter: T | string) => void}
            value={value}
            width="15rem"
            minNumOfOptionsToShowSearchBox={10}
          />
          <Button
            size="md"
            severity="low"
            data-testid="sort-button"
            icon={isAscending ? "sortAscending" : "sortDescending"}
            onClick={() =>
              onSortChange(isAscending ? SortOrder.Desc : SortOrder.Asc)
            }
            type="button"
          />
        </StyledDropdown>
      </FlexContainer>
    </FlexContainer>
  );
}
